import { render } from "./QuestionWithImageAnswers.vue?vue&type=template&id=2084385c"
import script from "./QuestionWithImageAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionWithImageAnswers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__